import { Customer, CustomerTable } from "./customer";
import {
  ChequeBuilder,
  ChequeBuilderBackend,
  Cheque,
  ChequeStatus,
  ChequeStatusType,
  ChequeUpdate,
  ChequeSelectorItem,
} from "./cheque";
import { Bank, BankName } from "./bank";
import { Factor, FactorTypeName, FactorType } from "./factor";
import {
  CashBuilder,
  CashType,
  CashTypeName,
  CashBuilderBackend,
  CashQuery,
  CashQueryBackend,
  CashTable,
  Cash,
  CashUpdater,
  CashUpdaterBackend,
} from "./cash";
import {
  HistoryQuery,
  HistoryQueryKind,
  HistoryQueryKindCash,
  HistoryQueryKindCheque,
  HistoryQueryKindCustomer,
  HistoryQueryKindFactor,
} from "./history";
import {
  Room,
  Chat,
  ChatContainer,
  ChatBackend,
  ChatBuilder,
  ChatStatus,
  ChatMessage,
  ChatMessageId,
  ChatFilesType,
  ChatFileType,
} from "./chat";
import { Progress } from "./progress";
import { FC } from "react";

export type Color = string;

export enum Themes {
  Dark = 0,
  Light,
  VAR1,
  VAR2,
  VAR3,
}

export type Timestamp = number;

export interface DateRange {
  from: Timestamp;
  to: Timestamp;
}

export interface YMD {
  day: string;
  month: string;
  year: string;
}

export type SetDateRangeFn = (dr: DateRange) => void;

export interface ObjectId {
  $oid: string;
}

export interface Tag {
  color: Color;
  name: string;
  _id: ObjectId;
}

export interface LayoutProps {
  className?: string;
  style?: React.CSSProperties;
  props?: React.HTMLAttributes<HTMLDivElement>;
}

export interface By {
  id: ObjectId;
  fullname: string;
}

export type Updater<T> = T | ((prev: T) => T);
export type UpdateFn<T> = (v: Updater<T>) => void;

export interface Vec2 {
  x: number;
  y: number;
}

export interface BackType<T extends {}> {
  component: FC<T>;
  props: T;
}

export interface BackContainer<T, B extends {}> {
  data: T;
  back?: BackType<B>;
}

export {
  type Customer,
  type CustomerTable,
  type ChequeBuilder,
  type ChequeBuilderBackend,
  type Cheque,
  type ChequeStatus,
  type ChequeStatusType,
  type ChequeUpdate,
  type ChequeSelectorItem,
  type Bank,
  type BankName,
  type Factor,
  type FactorTypeName,
  type FactorType,
  type CashBuilder,
  type CashType,
  type CashTypeName,
  type CashBuilderBackend,
  type CashQuery,
  type CashQueryBackend,
  type CashTable,
  type Cash,
  type CashUpdater,
  type CashUpdaterBackend,
  type HistoryQuery,
  type HistoryQueryKind,
  type HistoryQueryKindCash,
  type HistoryQueryKindCheque,
  type HistoryQueryKindCustomer,
  type HistoryQueryKindFactor,
  type Room,
  type Chat,
  type ChatContainer,
  type ChatBackend,
  type ChatBuilder,
  ChatStatus,
  type ChatMessage,
  type ChatMessageId,
  type ChatFilesType,
  type ChatFileType,
  type Progress,
};
